import requestData from "@/http/request";
/**
 * 更新用户接收到的公告id
 * @param notice_id
 */
export function updateUserNoticeId({
  notice_id,
}) {
  return requestData('/appapi/auth/updateUserNoticeId', 'POST', {
    notice_id,
  })
}

/**
 * 获取用户接收到的最新公告号id
 */
export function getUserNoticeId() {
  return requestData('/appapi/auth/getUserNoticeId')
}

export function queryNoticeList() {
  return requestData('/appapi/jnnotice/querynoticelist');
}

export function homeInfo() {
  return requestData('/ucenter/ucApi');
}

export function checkWeChatBind() {
  return requestData('/weixinajax/checkWXbind');
}

export function unBindWeChatRequest() {
  return requestData('/weixinajax/unBind');
}

export function getNoticeListRequest() {
  return requestData('/appapi/jnnotice/getNoticeList');
}

export function queryNoticeDetailRequest(noticeId) {
  return requestData('/appapi/jnnotice/querynoticedetail?noticeid=' + noticeId);
}
export function getUnpaidServiceFee() {
  return requestData('/order/getUnpaidServiceFee', 'POST')
}